import $ from 'jquery';

export default class StencilDropdown {
    constructor(extendables) {
        this.extendables = extendables;
    }

    /**
     * @param $dropDown
     * @param style
     */
    hide($dropDown, style) {
        if (style) {
            $dropDown.attr('style', style);
        }

        // callback "hide"
        if (this.extendables && this.extendables.hide) {
            this.extendables.hide(event);
        }

        $dropDown.removeClass('is-open f-open-dropdown').attr('aria-hidden', 'true');
    }

    show($dropDown, event, style) {
        if (style) {
            $dropDown.attr('style', style).attr('aria-hidden', 'false');
        }

        $dropDown.addClass('is-open f-open-dropdown').attr('aria-hidden', 'false');

        // callback "show"
        if (this.extendables && this.extendables.show) {
            this.extendables.show(event);
        }
    }

    bind($dropDownTrigger, $container, style) {
        let modalOpened = false;

        $dropDownTrigger.on('click', (event) => {
            const $cart = $('.is-open[data-cart-preview]');

            if ($cart) {
                $cart.click();
            }

            if ($container.hasClass('is-open')) {
                this.hide($container, event);
            } else {
                this.show($container, event, style);
            }
        });

        $('body').click((e) => {
            // Call onClick handler
            if (this.extendables && this.extendables.onBodyClick) {
                this.extendables.onBodyClick(e, $container);
            }
        }).on('keyup', (e) => {
            // If they hit escape and the modal isn't open, close the search
            if (e.which === 27 && !modalOpened) {
                this.hide($container);
            }
        }).on('open.fndtn.reveal', '[data-reveal]', () => {
            modalOpened = true;
        }).on('close.fndtn.reveal', '[data-reveal]', () => {
            modalOpened = false;
        }).on('click', '[data-drop-down-close]', () => {
            modalOpened = false;
            this.hide($container);
        });
    }
}

$(document).ready(function(){	
	
	$(".brand_link a").click(function(){
		
		if($(".brand_link div").hasClass("is-open"))
		{
			$(".brand_link div").removeClass("is-open");
      
		}
		else
		{
			$(".brand_link div").addClass("is-open");
			$(".account_link div").removeClass("is-open");
			$(".cat_link div").removeClass("is-open");
			$(".page_link div").removeClass("is-open");
		}
	});
	$(".account_link a").click(function(){
		
		if($(".account_link div").hasClass("is-open"))
		{
			$(".account_link div").removeClass("is-open");
      
		}
		else
		{
			$(".account_link div").addClass("is-open");
			$(".brand_link div").removeClass("is-open");
			$(".cat_link div").removeClass("is-open");
			$(".page_link div").removeClass("is-open");
		}
	});
	$(".cat_link a").click(function(){
		
		if($(".cat_link div").hasClass("is-open"))
		{
			$(".cat_link div").removeClass("is-open");
      
		}
		else
		{
			$(".cat_link div#main_category").addClass("is-open");
			$(".brand_link div").removeClass("is-open");
			$(".account_link div").removeClass("is-open");
			$(".page_link div").removeClass("is-open");
		}
	});
	$(".page_link a.has-subMenu").click(function(){
		
		if($(".page_link div").hasClass("is-open"))
		{
			$(".page_link div").removeClass("is-open");
      
		}
		else
		{
			$(".page_link div").addClass("is-open");
			$(".brand_link div").removeClass("is-open");
			$(".account_link div").removeClass("is-open");
			$(".cat_link div").removeClass("is-open");
		}
	});
	$("#main_category .navPages-action-moreIcon").click(function(){

		if($( this).siblings( "div" ).hasClass( "is-open" ))
		{
			$( this).siblings( "div" ).removeClass("is-open");

      
		}
		else
		{
			$( this).siblings( "div" ).addClass("is-open");		}
	});
	$('body').on('click', 'a.modal-close',  function() {
			  $(".quickSearchResults div.container").remove();
	});
});


// WEBPACK FOOTER //
// ./assets/js/theme/global/stencil-dropdown.js